/** Bootstrap 5 `lg` — matches `navbar-expand-lg` and `d-lg-*` utilities */
export const BOOTSTRAP_LG = 992;

/** Tablet/small layouts that use the collapsible top nav (below Bootstrap lg) */
export const isBelowBootstrapLg = (width = typeof window !== 'undefined' ? window.innerWidth : BOOTSTRAP_LG) =>
  width < BOOTSTRAP_LG;
